import Button from 'tio-ui/components/button';
import Text from 'tio-ui/components/text';
import { t } from 'ember-intl';
import { PhPencilSimple } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

export interface DetailsRowSignature {
  Args: {
    /** Suffix of the row's `data-test-pslf-details-*` hooks, e.g. `name`. */
    rowKey: string;
    label: string;
    /** Rendered when the row is collapsed; a blank value shows the "not set" placeholder. */
    value: string;
    isEditing: boolean;
    /** Omitted for a row the employee cannot change from here, which then shows no Edit action. */
    onEdit?: () => void;
  };
  Blocks: {
    /** The inline editor, rendered in place of the value while `@isEditing`. */
    form?: [];
    /** Collapsed-state footnote — where the row explains itself or points elsewhere. */
    note?: [];
  };
}

/** One "Your details" row: label, current value, and an Edit action that swaps in an inline form. */
const DetailsRow: TOC<DetailsRowSignature> = <template>
  <div class="tio-col-extra-tight" data-test-pslf-details-row={{@rowKey}}>
    <div class="tio-row-between">
      <Text @size="sm" @weight="medium" @variant="muted">{{@label}}</Text>
      {{#if @onEdit}}
        {{#unless @isEditing}}
          <Button
            @appearance="link"
            @intent="primary"
            @size="sm"
            @icon={{PhPencilSimple}}
            @testHook="pslf-details__edit-{{@rowKey}}"
            data-test-pslf-details-edit={{@rowKey}}
            {{on "click" @onEdit}}
          >
            {{t "pslf.reimagined.annual_auto_submit.details.edit"}}
          </Button>
        {{/unless}}
      {{/if}}
    </div>

    {{#if @isEditing}}
      {{yield to="form"}}
    {{else}}
      <Text class="pii" data-test-pslf-details-value={{@rowKey}}>
        {{#if @value}}
          {{@value}}
        {{else}}
          {{t "pslf.reimagined.annual_auto_submit.details.empty"}}
        {{/if}}
      </Text>
      {{yield to="note"}}
    {{/if}}
  </div>
</template>;

export default DetailsRow;
